
import { useState } from "react";
import { ScrollToTop } from "./ScrollToTop";
import { User } from "@supabase/supabase-js";
import { useInfiniteScroll } from "@/hooks/useInfiniteScroll";
import { DealsHeader } from "./deals/DealsHeader";
import { DealsFilters } from "./deals/DealsFilters";
import { DealsGrid } from "./deals/DealsGrid";
import { DealsStats } from "./deals/DealsStats";
import { DealsLoadingState } from "./deals/DealsLoadingState";
import { useDealsData } from "./deals/useDealsData";

interface DealsProps {
  onBack: () => void;
  user?: User | null;
  favorites?: number[];
  onFavoriteChange?: () => void;
}

export const Deals = ({ onBack, user = null, favorites = [], onFavoriteChange = () => {} }: DealsProps) => {
  const [displayCount, setDisplayCount] = useState(20);
  const [searchTerm, setSearchTerm] = useState("");
  const [countryFilter, setCountryFilter] = useState("all");
  const [priceFilter, setPriceFilter] = useState("500");

  const { vacations, loading, countries } = useDealsData(searchTerm, countryFilter, priceFilter);

  const hasMoreResults = displayCount < vacations.length;
  const displayedVacations = vacations.slice(0, displayCount);

  const { shouldLoadMore, resetLoadMore } = useInfiniteScroll({
    hasNextPage: hasMoreResults,
    isLoading: loading
  });

  // Handle infinite scroll
  if (shouldLoadMore) {
    setDisplayCount(prev => Math.min(prev + 20, vacations.length));
    resetLoadMore();
  }

  return (
    <div className="space-y-6">
      <DealsHeader onBack={onBack} />
      
      <DealsFilters
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        countryFilter={countryFilter}
        setCountryFilter={setCountryFilter}
        priceFilter={priceFilter}
        setPriceFilter={setPriceFilter}
        countries={countries}
      />
      
      {loading ? (
        <DealsLoadingState />
      ) : (
        <>
          <DealsStats 
            displayedCount={displayedVacations.length} 
            totalCount={vacations.length} 
          />
          
          <DealsGrid
            vacations={displayedVacations}
            loading={loading}
            user={user}
            favorites={favorites}
            onFavoriteChange={onFavoriteChange}
          />

          {hasMoreResults && (
            <div className="text-center text-sm text-gray-500 py-4">
              Scroll naar beneden voor meer deals...
            </div>
          )}

          <ScrollToTop />
        </>
      )}
    </div>
  );
};
